import { TweenMax } from 'gsap';

export default function fade(el) {
  TweenMax.set(el, {
    y: 30,
    autoAlpha: 0,
  });

  return el;
}
